import classnames from 'classnames';
import sum from 'lodash/sum';
import { arrayOf, func, number, shape, string } from 'prop-types';
import React from 'react';
import { Col, Label } from 'reactstrap';

import MultiSelect from '../../../generic/MultiSelect';
import ShareInput from '../../../generic/ShareInput';
import { genders as GENDERS } from '../../../quotes/constants';

export default function QuoteLineGenderDetails({
  quoteLineId,
  genders,
  genderShares,
  onShareChange,
  onGenderChange,

  colDistribution: [labelSm, valueSm],
}) {
  const namePrefix = `quoteLines[${quoteLineId}]`;
  const shareSum = sum(Object.values(genderShares));
  return (
    <>
      <>
        <Label sm={labelSm} for={`${namePrefix}.genders`} className="mb-3">
          Genders
        </Label>
        <Col sm={valueSm} className="mb-3">
          <MultiSelect
            options={GENDERS}
            id={`${namePrefix}.genders`}
            name="genders"
            value={genders}
            onChange={onGenderChange}
            data-quote-line-id={quoteLineId}
          />
        </Col>
      </>
      {genders.length ? (
        <>
          <Label sm={labelSm} className="mb-3">
            Gender shares
          </Label>
          <Col sm={valueSm} className="d-flex mb-3">
            <div className="d-inline-block mr-2">
              ∑
              <br />
              <ShareInput
                className={classnames(
                  'form-control-plaintext-without-color-override-sm',
                  'text-nowrap',
                  {
                    'text-warning': shareSum !== 1,
                  },
                )}
                value={shareSum}
                displayType="text"
              />
            </div>
            {genders.map(gender => {
              const genderKey = `gender${gender}Share`;
              return (
                <div key={genderKey} className="d-inline-block mr-2">
                  {gender}
                  <br />
                  <ShareInput
                    bsSize="sm"
                    name={genderKey}
                    value={genderShares[genderKey]}
                    onChange={onShareChange}
                    data-quote-line-id={quoteLineId}
                  />
                </div>
              );
            })}
          </Col>
        </>
      ) : null}
    </>
  );
}

QuoteLineGenderDetails.propTypes = {
  quoteLineId: number.isRequired,
  genders: arrayOf(string.isRequired).isRequired,
  genderShares: shape({
    genderMenShare: number.isRequired,
    genderKidsShare: number.isRequired,
    genderWomenShare: number.isRequired,
  }).isRequired,
  onShareChange: func.isRequired,
  onGenderChange: func.isRequired,

  colDistribution: arrayOf(Col.propTypes.sm.isRequired).isRequired,
};
